import apiCaller from "../../../helper/apiCall";
import { VTS_ENDPOINTS } from "../../urls/endpoints";

/**
 * Fetch vehicle status counts (total/online/offline/motion/halt/idle/neverConnected/seal/unseal)
 */
const fetchVtsStatusCounts = async () => {
  const response = await apiCaller(VTS_ENDPOINTS.STATUS_COUNTS, "GET");
  return response;
};

/**
 * Fetch paginated vehicle list with live status/location
 * @param {Object} params
 * @param {number} params.page
 * @param {number} params.limit
 * @param {string} params.status - Filter by status (e.g. motion, halt, idle)
 * @param {string} params.search - Search by vehicle number
 */
const fetchVtsVehicles = async (params = {}) => {
  const dataToSend = {
    page: params.page || 1,
    limit: params.limit || 50,
  };
  if (params.status) dataToSend.status = params.status;
  if (params.search) dataToSend.search = params.search;
  const response = await apiCaller(VTS_ENDPOINTS.VEHICLES, "POST", dataToSend);
  return response;
};

/**
 * Fetch single vehicle detail (includes device/sim/account master info)
 * @param {Object} params
 * @param {string} params.imei
 * @param {string} params.vehicleNo
 */
const fetchVtsVehicleDetail = async (params) => {
  const dataToSend = {
    imei: params.imei,
    vehicleNo: params.vehicleNo,
  };
  const response = await apiCaller(VTS_ENDPOINTS.VEHICLE_DETAIL, "POST", dataToSend);
  return response;
};

/**
 * Fetch vehicle travel history (points + optional encoded polyline) for a date range
 * @param {Object} params
 * @param {string} params.imei
 * @param {string} params.vehicleNo
 * @param {string} params.startDate - "YYYY-MM-DD HH:mm:ss"
 * @param {string} params.endDate - "YYYY-MM-DD HH:mm:ss"
 * @param {boolean} params.polyline - Return an encoded polyline alongside raw points
 */
const fetchVtsVehicleHistory = async (params) => {
  const dataToSend = {
    imei: params.imei,
    vehicleNo: params.vehicleNo,
    startDate: params.startDate,
    endDate: params.endDate,
    polyline: params.polyline || false,
  };
  const response = await apiCaller(VTS_ENDPOINTS.VEHICLE_HISTORY, "POST", dataToSend);
  return response;
};

export {
  fetchVtsStatusCounts,
  fetchVtsVehicles,
  fetchVtsVehicleDetail,
  fetchVtsVehicleHistory,
};
